import styled from "styled-components/macro";

export default styled.table`
  margin: 0 auto;
  width: 100%;
  text-align: left;
  margin-top: 16px;

  thead {
    background-color: #3e82d7;
    width: 100%;
    color: ${({ theme }) => theme.color.line.light};
  }

  td,
  th {
    padding: 20px 10px;
  }

  tr:nth-child(even) {
    background: #e2edf9;
  }
`;
